import { create } from 'zustand'

interface AppUpdateState {
  /** True once a newer build has been downloaded and is waiting to take over. */
  ready: boolean
  /** Activates the waiting service worker and reloads. Set by the registration. */
  apply: () => void
  offer: (apply: () => void) => void
}

/**
 * The service worker's update prompt (issue #64).
 *
 * A new build is offered rather than applied: the worker downloads it in the
 * background and this holds it at the door until somebody says so. The
 * alternative — `registerType: 'autoUpdate'`, which reloads the moment the new
 * worker activates — would throw away whatever is half-typed, and the screen
 * most likely to be half-typed is a stocktake being walked round a building,
 * which is the whole reason any of this exists.
 *
 * A store rather than a callback passed down, because the registration happens
 * in `main.tsx` (it is the only place that may import the virtual module the
 * build generates) and the chip that shows it lives in `AppShell`.
 */
export const useAppUpdateStore = create<AppUpdateState>()((set) => ({
  ready: false,
  apply: () => {},
  offer: (apply) => set({ ready: true, apply }),
}))
